import { useEffect, useRef, useState } from 'react';
import { useI18n } from '@i18n/useI18n';
import { DateSelectContainer, DateSelector, LectureContainer, LectureItems, SelectAll, SubTitle } from './SickLessons.styled';
import moment from 'moment';
import { useStore } from '@store/appStore';
import db from '@utils/db';
import RainbowLoader from '@components/Loaders/RainbowLoader';
import LectureBlock from './LectureBlock';
import DateSelect from '../SickPeriod/DateSelect';
import Cal_Icon from "@assets/svg/new_calendar.svg"

interface IProps {
  studentId: string,
  studentUsername: string,
  selectLectures: (lectures, all) => void,
  selectedLectures: any,
  selectedDate:any,
  selectDate:(type, date) => void
}

export const SickLessons = (props: IProps) => {
  const i18n = useI18n();
  const { client, settings } = useStore();
  const [date, setDate] = useState(new Date())
  const [courses, setCourses] = useState(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    getCoursesForStudent()
  }, [props.studentUsername, props.selectedDate])

  const getCoursesForStudent = async () => {
    setLoading(true)
    let c = await db.Regi_GetCoursesByStudentName(props.studentUsername, moment(props.selectedDate), settings.USEMERIT, settings.USEPAUSE)    
    setCourses(c)
    setLoading(false)
  }

  return (<>

    <LectureContainer>
      {courses === null ? <RainbowLoader /> : <>

        <DateSelectContainer>
          <SubTitle>{i18n.t("date")}: </SubTitle>
          <DateSelect type={1} value={props.selectedDate} setDate={props.selectDate}>
            <DateSelector><span>{moment(props.selectedDate).format("DD-MM-YYYY")}</span><Cal_Icon /></DateSelector>
          </DateSelect>
        </DateSelectContainer>

        <SelectAll selected={false} onClick={() => props.selectLectures(courses.map(c => c.id), true)}>
          {props?.selectedLectures?.length > 0 ? i18n.t("clear-select") : i18n.t("select-all")}
        </SelectAll>
        <LectureItems>

          {loading?<RainbowLoader />:courses?.map((l, index) => {
            return <LectureBlock selectLectures={props.selectLectures} selected={props?.selectedLectures?.includes(l.id)} timeblock={l} />
          })}
        </LectureItems>
      </>}
    </LectureContainer>
  </>);
};

export default SickLessons;
